import { twMerge } from 'tailwind-merge';
import { ReactNode } from 'react';
import { ButtonHTMLAttributes } from 'react';

export const IconButton = ({
  icon,
  className,
  ...props
}: { icon: ReactNode; className?: string } & ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <button
      {...props}
      className={twMerge(
        'flex w-6 h-6 items-center justify-center bg-neutral-400 disabled:bg-neutral-500/50 rounded-full',
        className
      )}
    >
      {icon}
    </button>
  );
};
